import React, {Component} from 'react';
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import ActivityDetailComponent from '../components/classactivity/shenhe/shenhe.jsx';
import {closeActivityShenheModal,openDongtaiDetailModal} from "../redux/actions/modelsActive";
import {getActivityDetailRequest,getTianyuanListRequest,checkTianyuanRequest,addLiulanRequest,getActivityShenheListRequest,
    getActivityTypeListRequest} from "../service/activity";
import {FILE_URL} from "../util/constants";
import {Base64} from 'js-base64';
import defaultImg from "../img/bee.png";
import errorPhoto from "../img/ic_photo_error.png";

import PubSub from "pubsub-js";

class ActivityShenheContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'getActivityDetail',
            'getTianyuanList',
            'clickSuyuan',
            'handleImageErrored',
            'handleImageErrored2',
            'checkNo',
            'checkYes',
            'checkTianyuan',
            'chakanDongtai',
            'handleScroll',
            'addLiulan',
            'getActivityTypeList',
            'clickHuodongType',
            'clickShenheTab'
        ]);
        this.state = {
            huodong_info:{},
            huodong_suyang:[],
            suyang_code:'',
            tianyuanList:[
            ],
            huodong_img:'',
            activityTypeList:[],
            js_huodong_code:0,
            shenhe_status:0
        }

        // PubSub.unsubscribe('closeDongtaiDetailModal');
        // PubSub.subscribe('closeDongtaiDetailModal', (event, data) => {
        //     window.addEventListener('scroll', this.handleScroll, true);
        // });


        // PubSub.unsubscribe('deleteDongtai');
        // PubSub.subscribe('deleteDongtai', (event, data) => {
        //     for (let i = 0; i < this.state.tianyuanList.length; i++) {
        //         if (this.state.tianyuanList[i].tianyuanid === sessionStorage.getItem('tianyuanid')) {
        //             this.state.tianyuanList.splice(i, 1);
        //             this.setState({
        //                 tianyuanList: this.state.tianyuanList
        //             });
        //         }
        //     }
        // });

    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, true);
        this.getActivityTypeList();
        // this.getActivityDetail(0,this.state.js_huodong_code);

    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true);
    }

    getActivityTypeList(){
        getActivityTypeListRequest( (data) => {
            console.log(data)
            if (data.ret == '1') {
                this.setState({
                    activityTypeList:data.data,
                    js_huodong_code:data.data[0].js_huodong_code
                })

                this.getActivityDetail(0,data.data[0].js_huodong_code);

            }else{
                this.setState({
                    activityTypeList:[],
                    js_huodong_code:0
                })
                this.getActivityDetail(0,0);
            }
        })
    }

    chakanDongtai(tianyuanid){
        // sessionStorage.setItem('tianyuanid',tianyuanid);
        // this.addLiulan(tianyuanid);
        // this.props.openDongtaiDetailModal();
        //
        // window.removeEventListener('scroll', this.handleScroll, true);
    }

    addLiulan(tianyuanid){
        addLiulanRequest(tianyuanid, (data) => {
            console.log(data)

        });
    }

    clickShenheTab(code){
        if (code == this.state.shenhe_status) {

        } else {
            this.setState({
                shenhe_status:code
            });

            this.getActivityDetail(code,this.state.js_huodong_code);

        }
    }

    clickSuyuan(code){
        if (code == this.state.suyang_code) {

        } else {
            this.setState({
                suyang_code:code
            });

            this.getTianyuanList(code,'0');
        }
    }

    clickHuodongType(code){
        if (code == this.state.js_huodong_code) {

        } else {
            this.setState({
                js_huodong_code:code
            });
            this.getActivityDetail(this.state.shenhe_status,code,)
            //this.getTianyuanList(code,'0');
        }
    }

    handleImageErrored(index){

        var list = this.state.tianyuanList;
        list[index].teacher_img = defaultImg;

        this.setState({
            tianyuanList:list,
        });
    }

    handleImageErrored2(index,index0){

        var list = this.state.tianyuanList;
        list[index].img[index0].img = errorPhoto;

        this.setState({
            tianyuanList:list,
        });

    }

        //1 审核通过  3 未通过  0 未审核
    checkNo(tianyuanid,status){
        if(status=='3'){

        }else {
            this.checkTianyuan(tianyuanid,'3')
        }
    }

    checkYes(tianyuanid,status){
        if(status=='1'){

        }else {
            this.checkTianyuan(tianyuanid,'1')
        }

    }

    checkTianyuan(tianyuanid,status){
        checkTianyuanRequest(tianyuanid,status, (data) => {
            console.log(data)
            if(data.ret=='1'){
              this.getActivityDetail(this.state.shenhe_status,this.state.js_huodong_code)
            }
        });
    }


    getActivityDetail(status,js_huodong_code){
        getActivityShenheListRequest(status,js_huodong_code, (data) => {
            console.log(data)
            if(data.ret=='1'){
                var list = data.data;
                for (let i = 0; i < list.length; i++) {
                    list[i].teacher_img = list[i].teacher_img==null||list[i].teacher_img==''?'':FILE_URL+list[i].teacher_img

                    if(list[i].content.length>0){
                        list[i].content = Base64.decode(list[i].content[0].content)
                    }

                    if(list[i].img!==''){
                        for (let j = 0; j < list[i].img.length; j++) {
                            list[i].img[j].img = FILE_URL + list[i].img[j].img
                        }
                    }
                }

                this.setState({
                    tianyuanList:list
                });
            }else{
                this.setState({
                    tianyuanList:[]
                });
            }
        });
    }

    getTianyuanList(suyang_code,page){
        getTianyuanListRequest(sessionStorage.getItem('huodongcode'),suyang_code,page, (data) => {
            console.log(data)
            if(data.ret=='1'){

                var list = data.data;
                for (let i = 0; i < list.length; i++) {
                    list[i].teacher_img = list[i].teacher_img==null||list[i].teacher_img==''?'':FILE_URL+list[i].teacher_img

                    if(list[i].content.length>0){
                        list[i].content = Base64.decode(list[i].content[0].content)
                    }

                    if(list[i].img!==''){
                        for (let j = 0; j < list[i].img.length; j++) {
                            list[i].img[j].img = FILE_URL + list[i].img[j].img
                        }
                    }
                }

                this.setState({
                    tianyuanList:list
                });
            }else{
                this.setState({
                    tianyuanList:[]
                });
            }
        });
    }

    handleScroll(event) {
        const clientHeight = event.target.clientHeight
        const scrollHeight = event.target.scrollHeight
        const scrollTop = event.target.scrollTop

        var plusHeight = clientHeight + parseInt(scrollTop);
        var isBottom = (plusHeight === scrollHeight)

        if (isBottom) {
            console.log('加载更多')
        } else {
            console.log('没到达底部')
        }

        if (plusHeight == scrollHeight) {

            getTianyuanListRequest(sessionStorage.getItem('huodongcode'),this.state.suyang_code,this.state.tianyuanList.length, (data) => {
                console.log(data)
                if(data.ret=='1'){

                    var list = data.data;
                    for (let i = 0; i < list.length; i++) {
                        list[i].teacher_img = list[i].teacher_img==null||list[i].teacher_img==''?'':FILE_URL+list[i].teacher_img

                        if(list[i].content.length>0){
                            list[i].content = Base64.decode(list[i].content[0].content)
                        }
                    }

                    this.setState({
                        tianyuanList:this.state.tianyuanList.concat(list)
                    });
                }else{
                    // this.setState({
                    //     tianyuanList:[]
                    // });
                }
            });

        }
    }


    render() {

        return (
            <ActivityDetailComponent
                onRequestClose={this.props.closeActivityShenheModal}
                activityList={this.state.activityList}

                huodong_info={this.state.huodong_info}
                huodong_suyang={this.state.huodong_suyang}
                suyang_code={this.state.suyang_code}
                clickSuyuan={this.clickSuyuan}
                tianyuanList={this.state.tianyuanList}
                handleImageErrored={this.handleImageErrored}
                handleImageErrored2={this.handleImageErrored2}
                checkNo={this.checkNo}
                checkYes={this.checkYes}
                chakanDongtai={this.chakanDongtai}
                huodong_img={this.state.huodong_img}
                activityTypeList={this.state.activityTypeList}
                js_huodong_code={this.state.js_huodong_code}
                clickHuodongType={this.clickHuodongType}
                clickShenheTab={this.clickShenheTab}
                shenhe_status={this.state.shenhe_status}
            />
        )
    }


}

ActivityShenheContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeActivityShenheModal: () => dispatch(closeActivityShenheModal()),
        openDongtaiDetailModal: () => dispatch(openDongtaiDetailModal()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ActivityShenheContainer);
